import script from "./CargaGarantiaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CargaGarantiaModal.vue?vue&type=script&setup=true&lang=js"

import "./CargaGarantiaModal.vue?vue&type=style&index=0&id=338e5874&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-338e5874"]])

export default __exports__